import React from 'react';
import { Card, CardBody, CardTitle, Spinner, Table, Badge } from 'reactstrap';
import { EditPractitionerButton } from '../../../containers/Buttons';

const PractitionerProfileCard = (props: {
  displayName: string;
  firstName: string;
  familyName: string;
  gender: string;
  active?: boolean;
  practitionerRole?: string;
  email: string;
  loading?: boolean;
}) => (
  <Card>
    <CardBody>
      {!props.loading ? (
        <>
          <EditPractitionerButton className="float-right" />
          <CardTitle>
            <h3>{props.displayName}</h3>
          </CardTitle>
          <Table>
            <tbody>
              <tr>
                <td>
                  <b>Email</b>
                </td>
                <td>{props.email}</td>
              </tr>
              <tr>
                <td>
                  <b>First Name</b>
                </td>
                <td>{props.firstName}</td>
              </tr>
              <tr>
                <td>
                  <b>Last Name</b>
                </td>
                <td>{props.familyName}</td>
              </tr>
              <tr>
                <td>
                  <b>Gender</b>
                </td>
                <td>{props.gender}</td>
              </tr>
              <tr>
                <td>
                  <b>Role</b>
                </td>
                <td>{props.practitionerRole}</td>
              </tr>
              <tr>
                <td>
                  <b>Active</b>
                </td>
                <td>
                  {props.active ? (
                    <Badge color="success">Yes</Badge>
                  ) : (
                    <Badge color="danger">No</Badge>
                  )}
                </td>
              </tr>
            </tbody>
          </Table>
        </>
      ) : (
        <Spinner></Spinner>
      )}
    </CardBody>
  </Card>
);

export default PractitionerProfileCard;
